(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["icestark-vue-demo"] = factory();
	else
		root["icestark-vue-demo"] = factory();
})(window, function() {
return 